<template>
  <div>
    <h1>{{ 'auth_remember_password_form_title' | translate }}</h1>
    <h3>{{ 'auth_remember_password_form_subtitle' | translate }}</h3>

    <form @submit.prevent="submitForm">
      <div class="input-wrapper">
        <input
          v-model="email"
          type="email"
          placeholder="Email"
        >
        <i class="ri-mail-line ri-fw" />
      </div>

      <button
        class="secondary"
        :disabled="email.length === 0"
      >
        {{ 'auth_remember_password_form_button' | translate }}
      </button>
      <button type="button" class="previousPage" @click="loginPage">{{ 'd_ws_login_come_back' | translate }}</button>
    </form>
  </div>
</template>

<script>
  
import EmailSendSuccessfully from "../modals/EmailSendSuccessfully";
import UserNotFoundModal from "../modals/UserNotFoundModal";

export default {
  name: 'PasswordRestoreForm',
  data() {
    return {
      email: ''
    }
  },
  methods: {
    submitForm() {
      this.$crudService.post('remember_password', {email: this.email}).then(({data}) => {
        if (!data.hasOwnProperty('error')) {
          if (data.hasOwnProperty('status') && data.status === 'success') {
            this.$modal.show(EmailSendSuccessfully, {email: this.email}, {height: 'auto', adaptive: true})
          }
        } else {
          switch (data.code) {
          case 8:
            this.$modal.show(UserNotFoundModal, {}, {height: 'auto', adaptive: true});
            break;
          }
        }
      })
    },
    loginPage() {
      this.$emit('login-page')
    }
  }
}
</script>

<style lang="scss" scoped>
  .previousPage {
    width: auto;
    right: 0;
    border: none;
    background: none;
    margin: 20px auto 0 auto;
    height: auto;
    font-size: 12px;
    font-weight: normal;
    color: var(--label-tetriary);
  }
</style>
